// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
#subtitle-2 #images-count-title,
#subtitle-2 #images-count-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #images-count-title {
  font-size: 17px;
  font-weight: 700;
}
#subtitle-2 #images-count-add {
  text-align: right;
}
#subtitle-2 #images-count-add ion-button {
  margin: 0px;
  text-transform: capitalize;
  --padding-start: 0px;
  --padding-end: 24px;
  font-size: 13px;
  font-weight: 500;
}
#subtitle-2 #images-count-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.status {
  font-size: 14px;
  top: 4px;
}

ion-list {
  background: transparent;
}
ion-list .gallery-item {
  --background: transparent;
  --padding-start: 16px;
  --padding-end: 16px;
}
ion-list ion-card {
  margin: 0;
  margin-bottom: 2px;
  min-height: 180px;
  width: 100%;
  border-radius: 8px;
  z-index: 1;
}
ion-list ion-card ion-card-content div {
  margin-top: 32px;
  margin-bottom: 48px;
  max-height: 180px;
  font-size: 14px;
  font-weight: 500;
}
ion-list ion-card ion-card-content div.image {
  width: 100%;
  height: 180px;
  margin: 0;
  padding: 8px;
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  text-align: right;
}
ion-list ion-card ion-card-content div p {
  margin-top: 16px;
  margin-bottom: 16px;
}
ion-list .simple-header {
  font-size: 14px;
  font-weight: 500;
}
ion-list .simple-header ion-label {
  margin-top: 0;
}

.error-label {
  color: var(--ion-color-danger);
}

.error-feedback-wrapper {
  min-height: 18px;
  margin-top: 16px;
}
.error-feedback-wrapper .error-feedback {
  text-align: center;
}

.remove-image-icon {
  margin: 0;
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 2px black;
  border-radius: 50%;
  color: black;
  width: 24px;
  height: 24px;
}

ion-card-content {
  padding: 10px 0px;
}

.section-logo {
  margin-bottom: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  margin-left: 3px;
  margin-right: 3px;
}
.section-logo .container-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
  position: relative;
}
.section-logo .container-image ion-icon {
  position: absolute;
  bottom: -4px;
  right: -5px;
  background: var(--ion-color-primary);
  color: #ffffff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
}
.section-logo .container-image div {
  width: 131px;
  height: 131px;
  border-radius: 50%;
  padding: 5px;
  background-size: cover;
}
.section-logo .default-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
}
.section-logo .default-image img {
  width: 142px;
  height: 132px;
  border-radius: 50%;
  border: none;
}
.section-logo .business-name {
  color: var(--ion-color-primary);
  text-align: center;
  font-size: 22px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 16px;
}
.section-logo .company-name {
  color: #586677;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-top: 0px;
}

ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-primary) !important;
  --handle-background: #9f9f9e !important;
  --handle-background-checked: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/store-core/lib/components/detail-form/detail-form.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;;EAEE,UAAA;EACA,4BAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AACI;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACN;AACM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AACR;;AAKA;EACE,eAAA;EACA,QAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;AAGE;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AADJ;AAGE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AADJ;AAIM;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EAiBA,eAAA;EACA,gBAAA;AAlBR;AACQ;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,iBAAA;AACV;AAGQ;EACE,gBAAA;EACA,mBAAA;AADV;AASE;EACE,eAAA;EACA,gBAAA;AAPJ;AAQI;EACE,aAAA;AANN;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,gBAAA;EACA,gBAAA;AARF;AASE;EACE,kBAAA;AAPJ;;AAWA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AARF;AAUE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;EACA,kBAAA;AARJ;AAUI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AARN;AAWI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AATN;AAaE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;AAXJ;AAaI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAXN;AAeE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAdJ;;AAkBA;EACE,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AAfF","sourcesContent":["#subtitle-2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  #images-count-title,\n  #images-count-add {\n    width: 50%;\n    color: var(--ion-text-color);\n  }\n  #images-count-title {\n    font-size: 17px;\n    font-weight: 700;\n  }\n\n  #images-count-add {\n    text-align: right;\n    ion-button {\n      margin: 0px;\n      text-transform: capitalize;\n      --padding-start: 0px;\n      --padding-end: 24px;\n      font-size: 13px;\n      font-weight: 500;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n}\n\n.status{\n  font-size: 14px;\n  top: 4px;\n}\n\nion-list {\n  background: transparent;\n  .gallery-item {\n    --background: transparent;\n    --padding-start: 16px;\n    --padding-end: 16px;\n  }\n  ion-card {\n    margin: 0;\n    margin-bottom: 2px;\n    min-height: 180px;\n    width: 100%;\n    border-radius: 8px;\n    z-index: 1;\n\n    ion-card-content {\n      div {\n        margin-top: 32px;\n        margin-bottom: 48px;\n        max-height: 180px;\n        &.image {\n          width: 100%;\n          height: 180px;\n          margin: 0;\n          padding: 8px;\n          background-size: contain;\n          background-position: top;\n          background-repeat: no-repeat;\n          text-align: right;\n\n        }\n\n        p {\n          margin-top: 16px;\n          margin-bottom: 16px;\n        }\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .simple-header {\n    font-size: 14px;\n    font-weight: 500;\n    ion-label {\n      margin-top: 0;\n    }\n  }\n}\n\n.error-label {\n  color: var(--ion-color-danger);\n}\n\n.error-feedback-wrapper {\n  min-height: 18px;\n  margin-top: 16px;\n  .error-feedback {\n    text-align: center;\n  }\n}\n\n.remove-image-icon {\n  margin: 0;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ffffff;\n  box-shadow: 0px 0px 7px 2px black;\n  border-radius: 50%;\n  color: black;\n  width: 24px;\n  height: 24px;\n}\n\nion-card-content{\n  padding: 10px 0px;\n}\n\n.section-logo{\n  margin-bottom: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: center;\n  margin-left: 3px;\n  margin-right: 3px;\n\n  .container-image{\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n    position: relative;\n\n    ion-icon{\n      position: absolute;\n      bottom: -4px;\n      right: -5px;\n      background: var(--ion-color-primary);\n      color: #ffffff;\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n      padding: 8px;\n      cursor: pointer;\n    }\n\n    div{\n      width: 131px;\n      height: 131px;\n      border-radius: 50%;\n      padding: 5px;\n      background-size: cover;\n    }\n  }\n\n  .default-image{\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n\n    img{\n      width: 142px;\n      height: 132px;\n      border-radius: 50%;\n      border: none;\n    }\n  }\n\n  .business-name{\n    color: var(--ion-color-primary);\n    text-align: center;\n    font-size: 22px;\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n  .company-name{\n    color: #586677;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n    margin-top: 0px;\n  }\n}\n\nion-toggle {\n  --background: #dfdfdf !important;\n  --background-checked: var(--ion-color-primary) !important;\n  --handle-background: #9f9f9e !important;\n  --handle-background-checked: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
